module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "body body-override-3 sgc-2",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    staticClass: "no-style-override-8 sgc-1"
  }, [_vm._v("CONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "body body-override-3 sgc-4",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('a', {
    staticClass: "sgc-3",
    attrs: {
      "href": "#/Text/Acknowledgments"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "body body-override-3 sgc-4",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('a', {
    staticClass: "sgc-3",
    attrs: {
      "href": "#/Text/Introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "body body-override-3 sgc-4",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "body body-override-1 sgc-5",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/part1"
    }
  }, [_vm._v("Part I: ORIGINS")])]), _vm._v(" "), _c('p', {
    staticClass: "body body-override-1 sgc-5",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/01"
    }
  }, [_vm._v("Prologue: A Bit of Background")])]), _vm._v(" "), _c('p', {
    staticClass: "body body-override-1 sgc-5",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/02"
    }
  }, [_vm._v("The Scots-Irish Influence—Great Britain: Border Reivers and Woodkernes")])]), _vm._v(" "), _c('p', {
    staticClass: "body body-override-1 sgc-5",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Scots-Irish Influence— America: Cohees and Whiskey Boys")])]), _vm._v(" "), _c('p', {
    staticClass: "body body-override-1 sgc-5",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Scots-Irish Influence— The Civil War: Born Fighting")])]), _vm._v(" "), _c('p', {
    staticClass: "body body-override-1 sgc-5",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Highland Scots Influence: The War Cry of the Gael")])]), _vm._v(" "), _c('p', {
    staticClass: "body body-override-1 sgc-5",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Other Influences and Theories: Hounds, War Paint and the Georgia Bull")])]), _vm._v(" "), _c('p', {
    staticClass: "body body-override-1 sgc-5",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part II: SOUND OF THE YELL")])]), _vm._v(" "), _c('p', {
    staticClass: "body body-override-1 sgc-5",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Naming and Describing the Yell: The Ugliest Sound and the Sweetest Music")])]), _vm._v(" "), _c('p', {
    staticClass: "body body-override-1 sgc-5",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Word and Phrase Descriptions: Catamounts, Screech Owls and Banshees")])]), _vm._v(" "), _c('p', {
    staticClass: "body body-override-1 sgc-5",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Phonetic Descriptions: Keeooks, Yips and Who-eys")])]), _vm._v(" "), _c('p', {
    staticClass: "body body-override-1 sgc-5",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Recorded Versions of the Rebel Yell —Part I: D.W. Griffith, William Randolph Hearst and Ken Burns")])]), _vm._v(" "), _c('p', {
    staticClass: "body body-override-1 sgc-5",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Recorded Versions of the Rebel Yell —Part II: Duane Eddy, Arturo Toscanini and the UDC")])]), _vm._v(" "), _c('p', {
    staticClass: "body body-override-1 sgc-5",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Recorded Versions of the Rebel Yell —Part III: The UDC and the Museum of the Confederacy")])]), _vm._v(" "), _c('p', {
    staticClass: "body body-override-1 sgc-5",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part III: STORIES, POEMS, ETC.")])]), _vm._v(" "), _c('p', {
    staticClass: "body body-override-1 sgc-5",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    staticClass: "no-style-override-9"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The First and Last Rebel Yells: Mountain Boomers, Uncle Hade and the REA")])]), _vm._v(" "), _c('p', {
    staticClass: "body body-override-1 sgc-5",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    staticClass: "no-style-override-9"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Yankee Cheer: Hoo-rays, Hurrahs and Huzzas")])]), _vm._v(" "), _c('p', {
    staticClass: "body body-override-1 sgc-5",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    staticClass: "sgc-6"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Miscellaneous Stories, Articles and Quotes: Molly Cottontail and Little Sorrel")])]), _vm._v(" "), _c('p', {
    staticClass: "body body-override-1 sgc-5",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    staticClass: "sgc-6"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Poetry: Voice of the South")])]), _vm._v(" "), _c('p', {
    staticClass: "body body-override-1 sgc-5",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    staticClass: "sgc-6"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue: Conclusions")]), _c('span', {
    staticClass: "sgc-6"
  })]), _vm._v(" "), _c('p', {
    staticClass: "body body-override-1 sgc-5",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    staticClass: "sgc-6"
  }, [_vm._v("APPENDIXES")])]), _vm._v(" "), _c('p', {
    staticClass: "body body-override-1 sgc-5",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    staticClass: "sgc-6"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/ApendixA",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix A: Web Sites for Recorded Rebel Yell")]), _vm._v(" "), _c('span', {
    staticClass: "sgc-6"
  })]), _vm._v(" "), _c('p', {
    staticClass: "body body-override-1 sgc-5",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    staticClass: "sgc-6"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/ApendixB",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix B: Videos, DVDs and CDs for Recorded Rebel Yell")]), _c('span', {
    staticClass: "sgc-6"
  })]), _vm._v(" "), _c('p', {
    staticClass: "body body-override-1 sgc-5",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    staticClass: "sgc-6"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/ApendixC",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix C: Graphic of Sound Analysis")])]), _vm._v(" "), _c('p', {
    staticClass: "body body-override-1 sgc-5",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "body body-override-1 sgc-5",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "body body-override-1 sgc-5",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    staticClass: "sgc-7",
    attrs: {
      "href": "#/Text/SelectedBibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Selected Bibliography")]), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "body body-override-1 sgc-5",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    staticClass: "no-style-override-9"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d7b849f4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/contents.vue
// module id = 69
// module chunks = 0